export default "__VITE_ASSET__BCwgHAF9__"